/** @format */

import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useLocale } from "../../i18n/hooks";
import { Subject } from "../../types";
import DeleteSubject from "./DeleteSubject";

type Props = {
  subject: Subject;
  updateSaveList: (id: string, value: boolean) => void;
};

const SubjectRow: React.FC<Props> = ({ subject, updateSaveList }) => {
  const locale = useLocale();

  const [indexed, setIndexed] = useState<boolean>(!!subject.indexed);

  return (
    <tr>
      <td>
        <p className="mb-2">
          {subject.title[locale]} <br />
          <code>{subject.id}</code>
        </p>
      </td>
      <td>
        <Form.Check
          type="switch"
          id={`switch-${subject.id}`}
          label=""
          checked={indexed}
          onClick={() => {
            const value = !indexed;
            setIndexed(value);
            updateSaveList(subject.id, value);
          }}
        />
      </td>
      <td>
        <time role="time" dateTime={subject.created}>
          {new Date(subject.created ?? "").toLocaleDateString()}
        </time>
      </td>
      <td>
        <DeleteSubject subject={subject}/>
      </td>
    </tr>
  );
};

export default SubjectRow;
